module.exports = __webpack_public_path__ + "banquet/components/images/checkmark_large.eff557a68788292a6ddf504df2146624.png";


//////////////////
// WEBPACK FOOTER
// ./banquet/components/images/checkmark_large.png
// module id = 1698
// module chunks = 1